import React from 'react';
import { Home } from './Home';
import CheckInMainPage from '../../components/Forms/RSVP/CheckInMainPage'

export const CheckInMain = () => <Home><CheckInMainPage /></Home>;